export default "__VITE_ASSET__Cjuiz3OG__"